import { useState } from 'react';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Copy, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

const TextCounterTool = () => {
  const [text, setText] = useState('');

  const stats = {
    characters: text.length,
    charactersNoSpaces: text.replace(/\s/g, '').length,
    words: text.trim() ? text.trim().split(/\s+/).length : 0,
    sentences: text.trim() ? (text.match(/[.!?]+/g) || []).length : 0,
    paragraphs: text.trim() ? text.split(/\n\n+/).filter(p => p.trim()).length : 0,
    lines: text.trim() ? text.split(/\n/).length : 0,
  };

  const handleCopy = () => {
    const statsText = Object.entries(stats)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
    navigator.clipboard.writeText(statsText);
    toast.success('Stats copied to clipboard');
  };

  const handleClear = () => {
    setText('');
  };

  return (
    <div className="space-y-4" data-testid="text-counter-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Text Counter</h3>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={handleClear} data-testid="clear-text-btn">
            <RotateCcw className="w-4 h-4 mr-1" />
            Clear
          </Button>
          <Button variant="ghost" size="sm" onClick={handleCopy} data-testid="copy-stats-btn">
            <Copy className="w-4 h-4 mr-1" />
            Copy Stats
          </Button>
        </div>
      </div>

      <Textarea
        placeholder="Type or paste your text here..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="min-h-[200px] bg-background/50 resize-none"
        data-testid="text-input"
      />

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {Object.entries(stats).map(([key, value]) => (
          <div key={key} className="p-3 rounded-lg bg-background/50 border border-border">
            <div className="text-2xl font-bold text-primary" data-testid={`stat-${key}`}>{value}</div>
            <div className="text-xs text-muted-foreground capitalize">
              {key.replace(/([A-Z])/g, ' $1').trim()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextCounterTool;
